import { render, staticRenderFns } from "./PraticasPorPeriodo.vue?vue&type=template&id=2087f75c"
import script from "./PraticasPorPeriodo.vue?vue&type=script&lang=js"
export * from "./PraticasPorPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports